"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseQuoteToolWrapper = exports.BaseQuoteToolLauncher = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactGoogleRecaptchaV = require("react-google-recaptcha-v3");
var _reactRedux = require("react-redux");
var _react2 = require("redux-persist/integration/react");
var _store = require("../../store");
var _staffContextProvider = require("../../contextProviders/staffContextProvider");
var _baseQuoteToolRoutes = require("./baseQuoteToolRoutes");
var _slice = require("../../store/quote/slice");
var _selectors = require("../../store/quote/selectors");
var _thunks = require("../../store/quote/thunks");
var _usePrevious = require("../../hooks/usePrevious");
var _slice2 = require("../../store/app/slice");
var _handlers = require("./handlers");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var launcherPropTypes = {
  env: _propTypes["default"].string,
  // eslint-disable-next-line react/forbid-prop-types
  brandConfig: _propTypes["default"].any,
  staffMode: _propTypes["default"].bool,
  brokerFriendlyName: _propTypes["default"].string,
  staffName: _propTypes["default"].string,
  useMocks: _propTypes["default"].bool,
  showBrandSwitch: _propTypes["default"].bool,
  mockPet: _propTypes["default"].bool,
  mockPetType: _propTypes["default"].oneOf(['dog', 'cat']),
  mockOwner: _propTypes["default"].bool
};
var getSavedQuote = function getSavedQuote() {
  return (0, _selectors.savedQuoteSelector)(_store.store.getState());
};
var BaseQuoteToolWrapper = exports.BaseQuoteToolWrapper = function BaseQuoteToolWrapper(_ref) {
  var _document, _brandConfig$theme$br;
  var env = _ref.env,
    brandConfig = _ref.brandConfig,
    staffMode = _ref.staffMode,
    brokerFriendlyName = _ref.brokerFriendlyName,
    staffName = _ref.staffName,
    useMocks = _ref.useMocks,
    showBrandSwitch = _ref.showBrandSwitch,
    mockPet = _ref.mockPet,
    mockPetType = _ref.mockPetType,
    mockOwner = _ref.mockOwner;
  var _getSavedQuote = getSavedQuote(),
    savedQuote = _getSavedQuote.quote;
  var previousUseMocks = (0, _usePrevious.usePrevious)(useMocks);
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (useMocks) {
      _store.store.dispatch((0, _thunks.applyMockQuote)({
        mockPet: mockPet,
        mockPetType: mockPetType,
        mockOwner: mockOwner
      }));
    } else if (!useMocks && !previousUseMocks !== !useMocks) {
      _store.store.dispatch((0, _slice.resetQuote)());
    }
  }, [previousUseMocks, useMocks, mockPet, mockOwner, mockPetType]);
  var url = new URL((_document = document) === null || _document === void 0 ? void 0 : _document.location);
  var searchParams = new URLSearchParams(url === null || url === void 0 ? void 0 : url.search);
  var supportedQueryParameterList = [{
    name: 'promo',
    handler: _slice2.setPromo
  }, {
    name: 'species',
    handler: _slice2.setSpecies
  }, {
    name: 'petname',
    handler: _slice2.setPetName
  }, {
    name: 'breed',
    handler: _slice2.setBreed
  }, {
    name: 'code',
    handler: _slice2.setApplicationQuoteObjectId
  }, {
    name: 'partner',
    handler: function handler(partner) {
      return (0, _slice2.setPartner)({
        brandConfig: brandConfig,
        partner: partner
      });
    }
  }];
  (0, _handlers.persistQueryParameters)(searchParams, supportedQueryParameterList, dispatch);
  var partner = (0, _reactRedux.useSelector)(function (state) {
    return state.app.searchParams.partner;
  });
  var selectedBrandConfig = ((_brandConfig$theme$br = brandConfig.theme.brand) === null || _brandConfig$theme$br === void 0 || (_brandConfig$theme$br = _brandConfig$theme$br.brokers) === null || _brandConfig$theme$br === void 0 ? void 0 : _brandConfig$theme$br[partner]) || brandConfig;
  if (staffMode) {
    return /*#__PURE__*/_react["default"].createElement(_staffContextProvider.StaffContextProvider, {
      brokerFriendlyName: brokerFriendlyName,
      staffName: staffName
    }, /*#__PURE__*/_react["default"].createElement(_baseQuoteToolRoutes.BaseQuoteToolRoutes, {
      env: env,
      staffMode: staffMode,
      useMocks: useMocks,
      showBrandSwitch: showBrandSwitch,
      quoteData: savedQuote,
      brandConfig: selectedBrandConfig
    }));
  }
  return /*#__PURE__*/_react["default"].createElement(_baseQuoteToolRoutes.BaseQuoteToolRoutes, {
    env: env,
    staffMode: staffMode,
    useMocks: useMocks,
    showBrandSwitch: showBrandSwitch,
    quoteData: savedQuote,
    brandConfig: selectedBrandConfig
  });
};
BaseQuoteToolWrapper.propTypes = launcherPropTypes;
var BaseQuoteToolLauncher = exports.BaseQuoteToolLauncher = function BaseQuoteToolLauncher(_ref2) {
  var env = _ref2.env,
    brandConfig = _ref2.brandConfig,
    staffMode = _ref2.staffMode,
    brokerFriendlyName = _ref2.brokerFriendlyName,
    staffName = _ref2.staffName,
    useMocks = _ref2.useMocks,
    showBrandSwitch = _ref2.showBrandSwitch,
    mockPet = _ref2.mockPet,
    mockPetType = _ref2.mockPetType,
    mockOwner = _ref2.mockOwner;
  var siteKey = env === 'prod' ? brandConfig.quoteTools.recaptchaSiteKeyProd : brandConfig.quoteTools.recaptchaSiteKey;
  return siteKey ? /*#__PURE__*/_react["default"].createElement(_reactGoogleRecaptchaV.GoogleReCaptchaProvider, {
    reCaptchaKey: siteKey
  }, /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _store.store
  }, /*#__PURE__*/_react["default"].createElement(_react2.PersistGate, {
    loading: null,
    persistor: _store.persistor
  }, /*#__PURE__*/_react["default"].createElement(BaseQuoteToolWrapper, {
    env: env,
    brandConfig: brandConfig,
    staffMode: staffMode,
    brokerFriendlyName: brokerFriendlyName,
    staffName: staffName,
    useMocks: useMocks,
    showBrandSwitch: showBrandSwitch,
    mockPet: mockPet,
    mockPetType: mockPetType,
    mockOwner: mockOwner
  })))) : /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: _store.store
  }, /*#__PURE__*/_react["default"].createElement(_react2.PersistGate, {
    loading: null,
    persistor: _store.persistor
  }, /*#__PURE__*/_react["default"].createElement(BaseQuoteToolWrapper, {
    env: env,
    brandConfig: brandConfig,
    staffMode: staffMode,
    brokerFriendlyName: brokerFriendlyName,
    staffName: staffName,
    useMocks: useMocks,
    showBrandSwitch: showBrandSwitch,
    mockPet: mockPet,
    mockPetType: mockPetType,
    mockOwner: mockOwner
  })));
};
BaseQuoteToolLauncher.propTypes = launcherPropTypes;